import { useState } from "react";
import type { CaseRecord } from "../../types";
import { checkSummary, parseAudit } from "../../lib/extractionAudit";

// Expandable "Extraction audit" block shown below a record's metadata in
// the expanded view. Lists each deterministic check (date, sender,
// subject, …) as ✓ verified / ⚠ flagged so the user can spot and correct
// misextractions. Renders nothing when the record hasn't been audited.
export default function ExtractionAuditSection({
  record,
}: {
  record: CaseRecord;
}) {
  const report = parseAudit(record.extraction_audit);
  const [open, setOpen] = useState(false);
  if (!report || report.checks.length === 0) return null;

  const flaggedCount = report.checks.filter((c) => c.status === "flagged").length;

  return (
    <div className={`extraction-audit${report.flagged ? " flagged" : ""}`}>
      <button
        type="button"
        className="extraction-audit-toggle"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        {report.flagged ? "⚠" : "✓"} Extraction audit
        {flaggedCount > 0
          ? ` — ${flaggedCount} issue${flaggedCount === 1 ? "" : "s"}`
          : " — all verified"}
        <span className="extraction-audit-caret">{open ? " ▴" : " ▾"}</span>
      </button>
      {open && (
        <ul className="extraction-audit-list">
          {report.checks.map((c, i) => (
            <li key={i} className={`audit-${c.status}`}>
              <span aria-hidden>
                {c.status === "verified"
                  ? "✓"
                  : c.status === "flagged"
                    ? "⚠"
                    : "–"}
              </span>{" "}
              {checkSummary(c)}
              {c.issues.length > 1 && (
                <ul className="extraction-audit-subissues">
                  {c.issues.slice(1).map((iss, j) => (
                    <li key={j}>{iss}</li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
